import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BCAgenda } from 'src/app/models/custom/bcagenda';
import { AgendaService } from 'src/app/services/agenda.service';

@Component({
  selector: 'app-agenda-list',
  templateUrl: './agenda-list.component.html',
  styleUrls: ['./agenda-list.component.scss']
})
export class AgendaListComponent implements OnInit {

  @Output() agenda: EventEmitter<BCAgenda> = new EventEmitter();

  constructor(public agendaSrv: AgendaService) { }

  ngOnInit(): void {
    this.agendaSrv.loadAgendas();
  }

  select(agenda: BCAgenda) {
    this.agenda.emit(agenda);
  }
}
